var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app", page: _vm.setPageName() } },
    [
      _c("TopMenu"),
      _vm._v(" "),
      _c("router-view", { key: _vm.$route.path }),
      _vm._v(" "),
      _c("ForecastRunnerStatus"),
      _vm._v(" "),
      _vm.$store.state.error.show
        ? _c(
            "div",
            {
              staticClass: "modal show",
              on: {
                click: function ($event) {
                  return _vm.onCloseError()
                },
              },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("header", [
                  _vm._v(_vm._s(_vm.$store.state.error.data.type) + " "),
                  _c("span", { attrs: { title: "Close" } }),
                ]),
                _vm._v(" "),
                _c(
                  "article",
                  [
                    _vm.$store.state.error.data.hasError
                      ? [
                          _c(
                            "div",
                            { staticClass: "validation-error" },
                            _vm._l(
                              _vm.$store.state.error.message.errors,
                              function (item) {
                                return _c("div", [
                                  _c("h4", [_vm._v(_vm._s(item.text))]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    _vm._l(item.errors, function (error) {
                                      return _c(
                                        "li",
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(error.text) +
                                              "\n                                    "
                                          ),
                                          error.helper
                                            ? _c("HelperBox", {
                                                attrs: { text: error.helper },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  ),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      : [
                          _vm.hasErrorArray()
                            ? _c(
                                "ul",
                                _vm._l(
                                  this.$store.state.error.data.message,
                                  function (message) {
                                    return _c("li", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(message) +
                                          "\n                        "
                                      ),
                                    ])
                                  }
                                ),
                                0
                              )
                            : _vm.hasInnerErrorArray() ||
                              _vm.singleErrorMessage()
                            ? _c(
                                "div",
                                { staticClass: "validation-error" },
                                [
                                  _vm.singleErrorMessage()
                                    ? [
                                        _c("p", [
                                          _c("b", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  this.$store.state.error.data
                                                    .message
                                                ) +
                                                "\n                                "
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasInnerErrorArray()
                                    ? _c(
                                        "ul",
                                        [
                                          _vm._l(
                                            this.$store.state.error.data.data
                                              .messages,
                                            function (message) {
                                              return [
                                                message
                                                  ? _c("li", [
                                                      _vm._v(
                                                        "\n                                   " +
                                                          _vm._s(message) +
                                                          "\n                                "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                  ],
                  2
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }